import { hasValue, isEmptyString, extractEmailDomain } from 'utils/functions';

export function isEmail(email) {
  const emailReg = /^[!#$%&'*+-/=?^_`{|}~a-zA-Z0-9][.!#$%&'*+-/=?^_`{|}~a-zA-Z0-9\w]*@[-.a-zA-Z0-9]+(\.[-.a-zA-Z0-9]+)*\.([a-zA-Z0-9]+)$/;
  return emailReg.test(email);
}

export function isValidEmailDomain(email, validDomains) {
  const domain = extractEmailDomain(email);
  return validDomains.includes(domain);
}

export function isNaN(value) {
  const isString = typeof value === 'string';
  const isNumber = typeof value === 'number';
  const isStringOrNumber = isString || isNumber;
  const isEmptyStr = isString && isEmptyString(value);
  if (hasValue(value) && isStringOrNumber && !isEmptyStr) {
    return Number.isNaN(Number(value));
  }
  return true;
}

export function isAbove(value, maxValue) {
  return Number(value) > Number(maxValue);
}

export function isBelow(value, minValue) {
  return Number(value) < Number(minValue);
}

export function isOutsideRange(value, minValue, maxValue) {
  const numericValue = Number(value);
  return numericValue < Number(minValue) || numericValue > Number(maxValue);
}

export function isValidPasswordFormat(password) {
  if (password.length === password.trim().length && password.length >= 10) {
    const passwordFormat = new RegExp('^[\x20-\x7E]*$');
    return passwordFormat.test(password);
  }
  return false;
}

export default {
  isEmail,
  isValidEmailDomain,
  isNaN,
  isAbove,
  isBelow,
  isOutsideRange,
  isValidPasswordFormat
};
